<template>
  <div>
    <SpecialistsCatalog
      :show-side-menu="false"
      department-filter-variant="select"
      v-slot:list="{ people }"
    >
      <section class="staff-grid4-block">
        <div class="staff-grid4-block__card">
          <StaffGrid4PeopleList
            :people_list="people"
            :page-size="20"
            :show-qualification-category="false"
            :show-department="true"
            :open-photo-on-click="true"
            @open-photo="openPersonModal"
          />
        </div>
      </section>
    </SpecialistsCatalog>

    <StaffPersonModal
      v-if="selectedPerson"
      :person="selectedPerson"
      @close="closePersonModal"
    />
  </div>
</template>

<script>
import SpecialistsCatalog from '@/views/About/SpecialistsCatalog.vue';
import StaffGrid4PeopleList from '@/components/People/StaffGrid4PeopleList.vue';
import StaffPersonModal from '@/components/People/StaffPersonModal.vue';

export default {
  name: 'AppDoctors',
  components: { SpecialistsCatalog, StaffGrid4PeopleList, StaffPersonModal },
  data() {
    return {
      selectedPerson: null,
    };
  },
  metaInfo() {
    return {
      title: 'Специалисты | Алтайский краевой клинический перинатальный центр ДАР',
      meta: [
        {
          name: 'description',
          content:
            'Специалисты. Подробная информация о Алтайском краевом клиническом перинатальном центре ДАР.',
        },
        {
          name: 'keywords',
          content: 'Алтайский краевой клинический перинатальный центр',
        },
      ],
    };
  },
  methods: {
    openPersonModal(person) {
      if (!person) {
        return;
      }
      this.selectedPerson = person;
    },
    closePersonModal() {
      this.selectedPerson = null;
    },
  },
};
</script>

<style scoped lang="scss">
.staff-grid4-block {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.staff-grid4-block__card {
  width: 100%;
  max-width: 100%;
  padding: 24px 28px 28px;
  background: #fff;
  border: 1px solid #dfe5df;
  border-radius: 16px;
  box-sizing: border-box;
}

.staff-grid4-block__card ::v-deep .staff-grid4-item__photo {
  flex: 0 0 128px;
  width: 128px;
  height: 158px;
}

.staff-grid4-block__card ::v-deep .staff-grid4-item {
  gap: 14px;
  padding: 14px;
}

.staff-grid4-block__card ::v-deep .staff-grid4-item__name {
  font-size: 16px;
}

@media (max-width: 900px) {
  .staff-grid4-block__card {
    padding: 18px 16px 20px;
  }

  .staff-grid4-block__card ::v-deep .staff-grid4-item__photo {
    flex: 0 0 112px;
    width: 112px;
    height: 138px;
  }
}

@media (max-width: 767.98px) {
  .staff-grid4-block__card {
    padding: 12px 10px 14px;
    border-radius: 12px;
  }

  .staff-grid4-block__card ::v-deep .staff-grid4-item {
    gap: 12px;
    padding: 10px;
  }

  .staff-grid4-block__card ::v-deep .staff-grid4-item__photo {
    flex: 0 0 88px;
    width: 88px;
    height: 108px;
  }

  .staff-grid4-block__card ::v-deep .staff-grid4-item__name {
    font-size: 15px;
  }
}

@media (max-width: 479.98px) {
  .staff-grid4-block__card {
    padding: 8px 6px 10px;
  }

  .staff-grid4-block__card ::v-deep .staff-grid4-item__photo {
    flex: 0 0 76px;
    width: 76px;
    height: 94px;
  }
}
</style>
